/* esm.sh - websocket-ts@2.3.0 */
export * from "/*websocket-ts@2.3.0/esnext/websocket-ts.mjs";
